module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/ant.b5d805b7.png";